import React from "react";
import {
  CAvatar,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { storageService } from "Services/storage_service";
import { Icon } from "@mdi/react";
import { useNotificationTimer } from "Hooks/useNotificationTimer";
import { resetUI } from "Slices/uiSlice";
import { resetCapacitacion } from "Slices/Capacitacion/capacitacionSlice";
import { resetByteState } from "Slices/Byte/byteSlice";
import { resetReport } from "Slices/Report/reporteSlice";
import { resetResponse } from "Slices/Response/responseSlice";
import { resetDelegacion } from "Slices/Delegacion/delegacionSlice";
import { resetAuthUser } from "Slices/Login/loginSlice";
import { resetPermisos } from "Slices/Permisos/permisosSlice";
import { ROLES } from "Constantes/constants";
import { RUTAS } from "rutas";
import "../SideBar.css";
import avatar from "Recursos/avatar.png";

const AppHeaderDropdown = (props) => {
  const dispatch = useDispatch();
  const user = storageService.getItem("user");
  const exitIcon = require(`materialdesign-js/icons/mdiExitToApp`).default;
  const navigate = useNavigate();
  const { clearNotificationTimer } = useNotificationTimer();

  const handleLogout = () => {
    clearNotificationTimer();
    sessionStorage.clear();
    storageService.removeItem("user");
    dispatch(resetUI());
    dispatch(resetCapacitacion());
    dispatch(resetByteState());
    dispatch(resetReport());
    dispatch(resetResponse());
    dispatch(resetDelegacion());
    dispatch(resetPermisos());
    dispatch(resetAuthUser());
    storageService.removeItem("activarRenap");
    storageService.removeItem("contacto");
    storageService.removeItem("diasReporteria");
    storageService.removeItem("footer");
    storageService.removeItem("logoutTime");
    storageService.removeItem("urlFiles");
    storageService.removeItem("refreshToken");
    navigate(RUTAS.ADMIN_LOGIN);
  };

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle component="div" placement="bottom-end" className="py-0">
        <CAvatar className="m-2 me-2" src={avatar} size="md" />
        <span
          id="user-name"
          className="me-2 d-lg-inline-flex d-xl-inline-flex d-xxl-inline-flex"
          style={props.style}
        >
          {user?.idRol === ROLES.NO_CLIENTE.ID ? user?.nombre : user?.usuario}
        </span>
      </CDropdownToggle>
      <CDropdownMenu>
        <CDropdownItem component="button" onClick={handleLogout}>
          <div
            style={{ color: "#0046ad" }}
            className="d-flex justify-content-between align-items-center"
          >
            <label className="me-2 mb-0" style={props.style}>
              Cerrar sesión
            </label>
            <Icon path={exitIcon} size={1} className="nav-icon" />
          </div>
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};

export default AppHeaderDropdown;
